import { SeverityLevel } from '@sentry/react';

import { Sentry } from '@/app/libs/sentry/instance';
import { BreadcrumbCategory } from '@/app/libs/sentry/types/breadcrumb';

export function addBreadcrumb(message: string, level: SeverityLevel, category: BreadcrumbCategory) {
  Sentry.addBreadcrumb({ timestamp: Date.now(), category, message, level });
}
